
/* eslint-disable no-unused-vars */
function loginSubmit(token) {
	document.querySelector('.j-login').submit()
}

window.loginSubmit = loginSubmit
/* eslint-enable no-unused-vars */
